import { AnyAction } from 'redux'

import { TOGGLE_EDIT_PDF_MODAL } from '@actions/ui/editPDFModal'

const initialEditPDFModalState = { show: false }

export const editPDFModal = (
  state = initialEditPDFModalState,
  action: AnyAction,
) => {
  switch (action.type) {
    case TOGGLE_EDIT_PDF_MODAL:
      return { ...state, show: action.show }
    default:
      return state
  }
}
